import { render, staticRenderFns } from "./PropertySummary.vue?vue&type=template&id=3afd56ba&scoped=true"
import script from "./PropertySummary.vue?vue&type=script&lang=js"
export * from "./PropertySummary.vue?vue&type=script&lang=js"
import style0 from "./PropertySummary.vue?vue&type=style&index=0&id=3afd56ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd56ba",
  null
  
)

export default component.exports